var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showMarkup)?_c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"container"},[_c('main',{attrs:{"role":"main"}},[_c('router-view')],1)]),_c('NotificationsModal')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }